import React, { useEffect, useState } from "react";

//image

//Style
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
///Icon
import { TiWeatherCloudy } from "react-icons/ti";
import { FaLocationArrow } from "react-icons/fa";

///Component
import Loading_Pages from "./loading";

const renderTooltip = (value) => (
  <Tooltip id="slider-tooltip">{`${value}.00 น.`}</Tooltip>
);

function convertToDayOfWeek(datetimeString) {
  const datetime = new Date(datetimeString);
  const weekdays = [
    "วันอาทิตย์",
    "วันจันทร์",
    "วันอังคาร",
    "วันพุธ",
    "วันพฤหัสบดี",
    "วันศุกร์",
    "วันเสาร์",
  ];
  const dayIndex = datetime.getDay();
  return weekdays[dayIndex];
}

////Handle_ForeCast
function ForeCastElement(props) {
  const [isActive, setIsActive] = useState(props.forecast_Active);
  const [sliderTime, setSliderTime] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [dataWeather, setDataWeather] = useState(undefined);
  const [thisDayWeather, setThisDayWeather] = useState(undefined);
  const [displayActive, setDisplayActive] = useState(false);
  const [displayWeather, setDisplayWeather] = useState({
    icon: undefined,
    temp: undefined,
    prepci: undefined,
    humidity: undefined,
    wind: undefined,
    date: undefined,
    day: undefined,
    weather_text: undefined,
    wind_kph: undefined,
    wind_degree: undefined,
    wind_dir: undefined,
  });
  const [slideValue, setSlideValue] = useState(0);

  useEffect(() => {
    if (props.ForeCast_Data !== undefined) {
      console.log(props.ForeCast_Data);
      setDataWeather(props.ForeCast_Data);
      setThisDayWeather(props.ForeCast_Data.forecast.forecastday[0]);
      setDisplayWeather({
        ...displayWeather,
        icon: props.ForeCast_Data.current.condition.icon,
        temp: props.ForeCast_Data.current.temp_c,
        prepci: props.ForeCast_Data.current.precip_in,
        humidity: props.ForeCast_Data.current.humidity,
        wind: props.ForeCast_Data.current.wind_mph,
        date: props.ForeCast_Data.current.last_updated,
        weather_text: props.ForeCast_Data.current.condition.text,
        location: props.ForeCast_Data.location,
        wind_kph: props.ForeCast_Data.current.wind_kph,
        wind_degree: props.ForeCast_Data.current.wind_degree,
        wind_dir: props.ForeCast_Data.current.wind_dir,
      });
    }
  }, [props.ForeCast_Data]);

  useEffect(() => {
    //console.log(displayActive);
    if (thisDayWeather !== undefined && displayActive === false) {
      ChangeDisplayWeather(slideValue, 0, "slider");
    }
  }, [slideValue]);

  function ChangeDisplayWeather(value, index, from) {
    //console.log(value, index, from,displayActive);
    if (from === "slider") {
      setDisplayWeather({
        ...displayWeather,
        icon: thisDayWeather.hour[value].condition.icon,
        temp: thisDayWeather.hour[value].temp_c,
        prepci: thisDayWeather.hour[value].precip_in,
        humidity: thisDayWeather.hour[value].humidity,
        wind: thisDayWeather.hour[value].wind_mph,
        date: thisDayWeather.hour[value].time,
        weather_text: thisDayWeather.hour[value].condition.text,
        wind_kph: thisDayWeather.hour[value].wind_kph,
        wind_degree: thisDayWeather.hour[value].wind_degree,
        wind_dir: thisDayWeather.hour[value].wind_dir,
      });
    } else {
      const date = new Date();
      const timeEpochInSeconds = Math.floor(date.getTime() / 1000);
      const crossToNextDate = 86400 * index;
      const findClosestIndex = (arr, target) => {
        let closestIndex = -1;
        let closestDifference = Infinity;

        arr.forEach((item, index) => {
          const difference = Math.abs(item.time_epoch - target);
          if (difference < closestDifference) {
            closestDifference = difference;
            closestIndex = index;
          }
        });

        return closestIndex;
      };
      let index_finder = findClosestIndex(
        value.hour,
        timeEpochInSeconds + crossToNextDate
      );
      console.log(
        value,
        index,
        index_finder,
        timeEpochInSeconds,
        crossToNextDate,
        thisDayWeather.hour[index_finder].time
      );
      setSlideValue(0);
      setDisplayWeather({
        ...displayWeather,
        icon: value.hour[index_finder].condition.icon,
        temp: value.hour[index_finder].temp_c,
        prepci: value.hour[index_finder].precip_in,
        humidity: value.hour[index_finder].humidity,
        wind: value.hour[index_finder].wind_mph,
        date: value.date,
        weather_text: value.hour[index_finder].condition.text,
        wind_kph: value.hour[index_finder].wind_kph,
        wind_degree: value.hour[index_finder].wind_degree,
        wind_dir: value.hour[index_finder].wind_dir,
      });
      setSelectedItem(index);
      setTimeout(() => {
        setDisplayActive(false);
      }, 250);
    }
  }
  ///Send to Other page
  const handleClose = () => {
    setIsActive(false);
    props.getHandle(false);
  };
  useEffect(() => {
    setIsActive(props.forecast_Active);
    props.getHandle(props.forecast_Active);
  }, [props.forecast_Active]);

  return isActive === true ? (
    <>
      {dataWeather !== undefined ? (
        <>
          <div
            className="icon-card-map"
            onClick={() => {
              setIsActive(!isActive);
            }}
          >
            <TiWeatherCloudy className="icon-weather" />
          </div>
          <div
            className="weather-card-container"
            style={{
              position: "absolute",
              width: "650px",
              height: "350px",
              bottom: "0px",
              right: "0px",
         
            }}
          >
            {}
            <Tabs
              defaultActiveKey="Precipitation"
              id="uncontrolled-tab-example"
              className="mb-3"
              justify
            >
              <Tab
                eventKey="Precipitation"
                title={
                  <span
                    className="tabplan"
                    style={{
                      color: "#0077B6",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    สภาพอากาศ
                  </span>
                }
              >
                <div id="body">
                  <div
                    style={{
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={displayWeather.icon}
                      style={{
                        width: "64px",
                        height: "64px",
                      }}
                    />
                    {/* src={`${ImageWeather(displayWeather.condition.icon)}`} */}
                    <div
                      style={{
                        display: "block",
                        width: "15%",
                        textAlign: "center",
                      }}
                    >
                      <div
                        id="temp"
                        style={{
                          fontSize: "30px",
                          display: "inline-block",
                          marginLeft: "10px",
                        }}
                      >
                        {displayWeather.temp}{" "}
                      </div>
                      <div
                        id="°C/°F"
                        style={{
                          display: "inline-block",
                          verticalAlign: "top",
                          marginLeft: "5px",
                        }}
                      >
                        °C
                      </div>
                    </div>
                    <div
                      style={{
                        width: "25%",
                        color: "#9aa0a6",
                        display: "inline-block",
                        fontSize: "12px",
                        lineHeight: "16px",
                        paddingTop: "6px",
                      }}
                    >
                      <div>โอกาสการเกิดฝน : {displayWeather.prepci}%</div>
                      <div>ความชื้น: {displayWeather.humidity}%</div>
                      <div>ลม: {displayWeather.wind} mph</div>
                    </div>
                    <div style={{ textAlign: "right", width: "50%" }}>
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "16px",
                        }}
                      >
                        {" "}
                        {displayWeather.date}
                      </div>
                      <div>{convertToDayOfWeek(displayWeather.date)}</div>
                      <div>{displayWeather.weather_text}</div>
                      <div>
                        พื้นที่ : {displayWeather.location.name},
                        {displayWeather.location.region}
                      </div>
                    </div>
                  </div>
                  <div
                    className="custom-slider-container"
                    style={{ padding: "10px" }}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip("เวลา: " + slideValue)}
                    >
                      <Form.Range
                        value={slideValue}
                        min={0}
                        max={23}
                        step={1}
                        defaultValue={slideValue}
                        onChange={(e) => {
                          setSlideValue(e.target.value);
                        }}
                      />
                    </OverlayTrigger>
                    {/* <div className="marks-container" disabled>
                                                {[...Array(24).keys()].map((mark, index) => (
                                                    <span key={index} style={{ color: "gray" }}>{mark}</span>
                                                ))}
                                            </div> */}
                  </div>

                  {/* <div className={`grid-container-` + 3} style={{ height: "150px" }}> */}
                  <div
                    className={
                      `grid-container-` +
                      dataWeather.forecast.forecastday.length
                    }
                    style={{ height: "150px" }}
                  >
                    {dataWeather.forecast.forecastday.map((value, index) => {
                      const isSelected = index === selectedItem;
                      return (
                        <div
                          className={`grid-item ${
                            isSelected ? "weather-selected" : "weather"
                          }`}
                          key={index}
                          onClick={() => {
                            ChangeDisplayWeather(value, index);
                            setThisDayWeather(value);
                            setDisplayActive(true);
                          }}
                        >
                          <div id="day" style={{ fontSize: "14px" }}>
                            {convertToDayOfWeek(value.date)}
                          </div>
                          <div id="picWeather">
                            <img
                              src={value.day.condition.icon}
                              style={{ width: "58px", height: "60px" }}
                            />
                          </div>

                          <div
                            id="minmax °C"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              fontSize: "14px",
                            }}
                          >
                            <div id="max °C" style={{ marginRight: "10px" }}>
                              {" "}
                              {value.day.mintemp_c}°
                            </div>
                            <div id="mix °C" style={{ opacity: "0.6" }}>
                              {value.day.maxtemp_c}°
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Tab>
              <Tab
                eventKey="Wind"
                title={
                  <span
                    className="tabplan"
                    style={{
                      color: "#0077B6",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    ความเร็ว/ทิศทางลม
                  </span>
                }
              >
                <div id="body">
                  <div
                    style={{
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {displayWeather.wind_dir === undefined ? (
                      <>
                        <img
                          src={displayWeather.icon}
                          style={{
                            width: "64px",
                            height: "64px",
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <div id="picWind-compass" className="compass-container">
                          <FaLocationArrow
                            className={`compass-arrow ${displayWeather.wind_dir}`}
                          />
                        </div>
                      </>
                    )}

                    {/* src={`${ImageWeather(displayWeather.condition.icon)}`} */}
                    <div
                      style={{
                        display: "block",
                        width: "15%",
                        textAlign: "center",
                      }}
                    >
                      <div
                        id="temp"
                        style={{
                          fontSize: "30px",
                          display: "inline-block",
                          marginLeft: "10px",
                        }}
                      >
                        {displayWeather.temp}{" "}
                      </div>
                      <div
                        id="°C/°F"
                        style={{
                          display: "inline-block",
                          verticalAlign: "top",
                          marginLeft: "5px",
                        }}
                      >
                        °C
                      </div>
                    </div>
                    <div
                      style={{
                        width: "25%",
                        color: "#9aa0a6",
                        display: "inline-block",
                        fontSize: "12px",
                        lineHeight: "16px",
                        paddingTop: "6px",
                      }}
                    >
                      <div>ความเร็วลม : {displayWeather.wind} m/h </div>
                      <div>ความเร็วลม : {displayWeather.wind_kph} k/h </div>
                      <div>
                        degree: {displayWeather.wind_dir}{" "}
                        {displayWeather.wind_degree}°
                      </div>
                    </div>
                    <div style={{ textAlign: "right", width: "50%" }}>
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "16px",
                        }}
                      >
                        {" "}
                        {displayWeather.date}
                      </div>
                      <div>{convertToDayOfWeek(displayWeather.date)}</div>
                      <div>{displayWeather.weather_text}</div>
                      <div>
                        พื้นที่ : {displayWeather.location.name},
                        {displayWeather.location.region}
                      </div>
                    </div>
                  </div>
                  <div
                    className="custom-slider-container"
                    style={{ padding: "10px" }}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip("เวลา: " + slideValue)}
                    >
                      <Form.Range
                        value={slideValue}
                        min={0}
                        max={23}
                        step={1}
                        defaultValue={slideValue}
                        onChange={(e) => {
                          setSlideValue(e.target.value);
                        }}
                      />
                    </OverlayTrigger>
                  </div>

                  {/* <div className={`grid-container-` + 3} style={{ height: "150px" }}> */}
                  <div
                    className={
                      `grid-container-` +
                      dataWeather.forecast.forecastday.length
                    }
                    style={{ height: "150px" }}
                  >
                    {dataWeather.forecast.forecastday.map((value, index) => {
                      const isSelected = index === selectedItem;

                      return (
                        <div
                          className={`grid-item ${
                            isSelected ? "weather-selected" : "weather"
                          }`}
                          key={index}
                          onClick={() => {
                            ChangeDisplayWeather(value, index);
                            setThisDayWeather(value);
                            setDisplayActive(true);
                          }}
                        >
                          <div id="day" style={{ fontSize: "14px" }}>
                            {convertToDayOfWeek(value.date)}
                          </div>
                          <div id="picWeather">
                            <img
                              src={value.day.condition.icon}
                              style={{ width: "58px", height: "60px" }}
                            />
                          </div>

                          <div
                            id="minmax °C"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              fontSize: "14px",
                            }}
                          >
                            <div id="max °C" style={{ marginRight: "10px" }}>
                              {" "}
                              {value.day.mintemp_c}°
                            </div>
                            <div id="mix °C" style={{ opacity: "0.6" }}>
                              {value.day.maxtemp_c}°
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Tab>
            </Tabs>
            <button
              className="close-button"
              onClick={() => {
                handleClose();
              }}
            >
              X
            </button>
          </div>
        </>
      ) : (
        <>
          <div
            className="icon-card-map"
            onClick={() => {
              setIsActive(!isActive);
            }}
          >
            <TiWeatherCloudy className="icon-weather" />
          </div>
          <div
            className="weather-card-container"
            style={{
              width: "650px",
              height: "350px",
              bottom: "28px",
              right: "30px",
              padding: "0px",
            }}
          >
            <div>
              <h3
                className="sidebar-header"
                style={{
                  fontSize: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                สภาพอากาศ
              </h3>
            </div>
            <Loading_Pages />
            <button
              className="close-button"
              onClick={() => {
                handleClose();
              }}
            >
              X
            </button>
          </div>
        </>
      )}
    </>
  ) : (
    <div
      className="icon-card-map"
      onClick={() => {
        setIsActive(!isActive);
      }}
    >
      <TiWeatherCloudy className="icon-weather" />
    </div>
  );
}

export default ForeCastElement;
